<template>
  <div>
    <span class="text-gray-800 font-semibold text-base my-4">Credit Card <span class="text-red-800 font-bold">*</span></span>
    <div class="text-red-900 mb-2" v-if="errorDescription" v-html="errorDescription"></div>
    <div id="card-container"></div>
  </div>
</template>
<script>

// eslint-disable-next-line
async function initializeCard(payments) {
  const card = await payments.card();
  // @TODO: Card widget isn't showing up in production for baker signup. Still showing up for subscriber signup.
  console.log("Card set");
  await card.attach('#card-container');
  console.log("Card attached");

  return card;
}

  export default {
    props: {
      appId: {
        type: String,
        required: true,
      },
      locationId: {
        type: String,
        required: true,
      },
      errorDescription: {
        type: String,
        default: ""
      }
    },
    async mounted () {
      if (window.Square) {
        console.debug('payments info being set', this.appId, this.locationId);
        this.payments = window.Square.payments(this.appId, this.locationId);

        try {
          // eslint-disable-next-line
          console.log("Attempting to set payment", this.payments);
          this.card = await initializeCard(this.payments);
          console.debug("card set", this.card);
          this.$emit('square-card-created', this.card);
        } catch (e) {
          console.error('Initializing Card failed', e);
        }
      } else {
        console.log("Square library not initialized");
      }
    },
  }
</script>
